import { render, staticRenderFns } from "./VenueFacilitiesPage.vue?vue&type=template&id=a3544e24&scoped=true"
import script from "./VenueFacilitiesPage.vue?vue&type=script&lang=ts"
export * from "./VenueFacilitiesPage.vue?vue&type=script&lang=ts"
import style0 from "./VenueFacilitiesPage.vue?vue&type=style&index=0&id=a3544e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3544e24",
  null
  
)

export default component.exports